import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Input, Button } from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import { encryptStorage } from "../../constants/EncryptStorage";
import { applyClassToCharacters } from "../../constants/const";

import { ApiUnit } from "../unit/ApiUnit";
import { GetSelectedLanguage } from "../helper/Method";
import { GoArrowLeft, GoArrowRight } from "react-icons/go";

const EventParticipantSelectUnit = ({
  setValues,
  values,
  eventUnitId,
  setSearchEventParticipants,
  searchEventParticipants,
  forChildUnit,
  includeSubHalqa,
}) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [unitList, setUnitList] = useState([]);
  const [unitId, setUnitid] = useState(eventUnitId);

  const unitTypeName = "null";

  useEffect(() => {
    ApiUnit()
      .checkIsValidChild(eventUnitId, loggedInUnitId)
      .then((res) => {
        if (res.data) setUnitid(eventUnitId);
        else setUnitid(loggedInUnitId);
      })
      .catch((err) => console.log(err));
  }, [eventUnitId, loggedInUnitId, unitId]);

  useEffect(() => {
    ApiUnit()
      .getUnitList(unitId, unitId, false, unitTypeName, true)
      .then((res) => {
        setUnitList(res.data);
      })
      .catch((err) => console.log(err));
  }, [unitId]);

  const handleChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(record.value, unitId, false, unitTypeName, true)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));

      setValues({
        ...values,
        unit: record,
      });
    }
  };

  const handleSubUnits = (e) => {
    const { value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setValues({
      ...values,
      isSubUnits: v,
    });
  };

  const handleSubmit = (e) => {
    setSearchEventParticipants({
      ...searchEventParticipants,
      unitId: values.unit.value,
      isSubUnits: values.isSubUnits,
      activePage: 1,
    });
  };

  return (
    <div className="eps-panel">
      {forChildUnit ? (
        <>
          <div className="eps-title">
            <GetLanguageString props="member_select_unit" />
          </div>
          <div className="eps-units">
            {unitList.map((record, index) => {
              const unitOptions = [];
              record.unitList.forEach((d) => {
                if (includeSubHalqa || d.unitTypeName !== "ZeliHalqa") {
                  unitOptions.push({
                    value: d.id,
                    label: d.name,
                    unitName: d.unitTypeName,
                  });
                }
              });

              let selected = {};
              if (record.selectedUnit !== null) {
                selected = {
                  value: record.selectedUnit.id,
                  label: record.selectedUnit.name,
                };
              }

              const isLastIndex = index === unitList.length - 1;

              return (
                <div className="eps-unit" key={index}>
                  <Select
                    options={unitOptions}
                    value={selected}
                    className="basic-single no-drag eps-select"
                    classNamePrefix="select"
                    onChange={handleChangeUnits}
                    formatOptionLabel={(option) =>
                      applyClassToCharacters(option.label, "ur")
                    }
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                  {isLastIndex ? null : (
                    <span className="eps-arrow" aria-hidden="true">
                      {GetSelectedLanguage() === "en" ? (
                        <GoArrowRight size={18} />
                      ) : (
                        <GoArrowLeft size={18} />
                      )}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </>
      ) : null}
      <div className="eps-actions">
        {forChildUnit ? (
          <label className="eps-check" htmlFor="subUnit">
            <Input
              id="subUnit"
              type="checkbox"
              name="isSubUnits"
              checked={values.isSubUnits}
              value={!values.isSubUnits}
              onChange={handleSubUnits}
            />
            <span>
              <GetLanguageString props="member_search_member_sub_unit" />
            </span>
          </label>
        ) : (
          <span />
        )}
        <Button
          color="primary"
          className="eps-search"
          type="submit"
          onClick={handleSubmit}
        >
          {<GetLanguageString props="common_search" />}
        </Button>
      </div>
    </div>
  );
};

export default EventParticipantSelectUnit;
